import { BaseError, createErrorBuilder, } from '@wix/public-editor-platform-errors';
export var RefComponentsErrorCode;
(function (RefComponentsErrorCode) {
    RefComponentsErrorCode["CompIsNotAReferredCompError"] = "CompIsNotAReferredCompError";
    RefComponentsErrorCode["UnableToFindAnOwnerError"] = "UnableToFindAnOwnerError";
    RefComponentsErrorCode["NotAllowedToChangeRefComponent"] = "NotAllowedToChangeRefComponent";
    RefComponentsErrorCode["UnableToFindComponentBySelector"] = "UnableToFindComponentBySelector";
    RefComponentsErrorCode["UnableToGetHiddenNoneRefComponents"] = "UnableToGetHiddenNoneRefComponents";
    RefComponentsErrorCode["UnableToFindRefComponent"] = "UnableToFindRefComponent";
})(RefComponentsErrorCode || (RefComponentsErrorCode = {}));
class RefComponentsError extends BaseError {
    constructor(message, code) {
        super(message, code, 'RefComponentsError');
        this.state = {};
    }
    withComponentId(componentId) {
        this.state.componentId = componentId;
        return this;
    }
    withSelector(selector) {
        this.state.selector = selector;
        return this;
    }
    withRootComponentId(rootComponentId) {
        this.state.rootComponentId = rootComponentId;
        return this;
    }
}
export const createRefComponentsError = createErrorBuilder(RefComponentsError);
//# sourceMappingURL=RefComponentsError.js.map